import activityLogServices from '../services/activityLogServices.js';

import dataModel from '../models/DataModel.js';
import DAO from './DAO.js';

//only used for the retrieval of activities and sub types in order to log event histories
//singleton data that is normalized to store here and not by regular patterns
export default class ActivitiesDAO extends DAO {

  setActivitiesAction(activities){
    return {
      type: 'ACTIVITIES_SET',
      activities,
    };
  }

  clearActivitiesAction() {
    return {
      type: 'ACTIVITIES_CLEAR',
    };
  }

  findActivity(activityName) {
    const storedActivities = Object.values(this.stateTree.activities);
    return storedActivities[0] ? storedActivities.find(activity => {
      return activity.name == activityName; 
    }) : null;
  }

  setActivities(activities) {
    this.store.dispatch(this.setActivitiesAction(activities));
  }

  clearActivities() {
    this.store.dispatch(this.clearActivitiesAction());
  }

  getActivity(activityName) {
    const currentActivity = this.findActivity(activityName);

    // If not online don't fetch
    if (dataModel.isOffline) {
      return new Promise(resolve => {
        if (currentActivity && currentActivity._recordState) {
          currentActivity._recordState.pending = false;
          currentActivity._recordState.synced = true;
        }
        return resolve(currentActivity);
      });
    }

    if (!currentActivity) {
      return activityLogServices.getActivitiesList().then(response => {
        let activities = {};
        let activity_sub_types = {};
        let foundActivity;

        response.activities.forEach(activity => {
          activities[activity.id] = {
            id: activity.id, 
            name: activity.name,
          };

          if (activity.name == activityName) {
            foundActivity = activities[activity.id];
          }

          activity.activity_sub_types.forEach(sub_type => {
            activity_sub_types[sub_type.id] = {
              id: sub_type.id,
              name: sub_type.name,
              activity_id: activity.id,
            };
          });
        });

        this.setActivities(activities); 
        dataModel.activitySubTypesDAO.setActivitySubTypes(activity_sub_types);  
        return foundActivity;
      });

    } else {
      return Promise.resolve(currentActivity);
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/ActivitiesDAO.js